import { Outlet, Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import Header from "../../views/layout/Header";
import Sidebar from "../../views/layout/Sidebar";
import Estimates from "../../views/pages/HR/Sales/Estimates";
import CreateEstimate from "../../views/pages/HR/Sales/Estimates/createEstimate.jsx";
import EditEstimate from "../../views/pages/HR/Sales/Estimates/EditEstimate.jsx";
import AllEmpoyee from "../../views/pages/Employees/AllEmpoyee";
import AdminLeave from "../../views/pages/Employees/AdminLeave";
import EmployeeLeave from "../../views/pages/Employees/EmployeeLeave";
import AttendenceAdmin from "../../views/pages/Employees/Attendenceadmin";
import AttendanceEmployee from "../../views/pages/Employees/AttendenceEmployee";
import Department from "../../views/pages/Employees/Department";
import Designation from "../../views/pages/Employees/Designation";
import Profile from "../../views/pages/Profile/Profile";
import EmployeeList from "../../views/pages/Employees/EmployeeList";
import EmployeeSalary from "../../views/pages/HR/Payroll/EmployeeSalary.jsx";
import PaySlip from "../../../src/views/pages/HR/Payroll/Payslip";
import PayrollItems from "../../../src/views/pages/HR/Payroll/PayrollItems.jsx";
import Fields from "../../views/pages/HR/Sales/Feilds/Fields.jsx";
import EmployeeProfile from "../../views/pages/Profile/EmployeeProfile.jsx";
import AdminDashboard from "../../views/pages/MainPages/Dashboard/AdminDashboard/adminDashboard.jsx";
import EmployeeDashboard from "../../views/pages/MainPages/Dashboard/EmployeeDashboard/index.jsx";
import Assets from "../../views/pages/HR/Assets/Assets.jsx";
import HolidayManagement from "../../views/pages/HR/Holiday/HolidayManagement.jsx";
import Calls from "../../views/pages/HR/Sales/Calls/index.jsx";
import CreateCall from "../../views/pages/HR/Sales/Calls/createCall.jsx";
import EditCall from "../../views/pages/HR/Sales/Calls/EditCall.jsx";
import DailyReport from "../../views/pages/HR/SalesReport/Daily.jsx";
import UserReport from "../../views/pages/HR/SalesReport/User.jsx";
import ProtectedRoute from "../../hooks/utils/ProtectedRoute.jsx";
import Error404 from "../../hooks/utils/Error/Error.jsx";
import Bids from "../../views/pages/Upwork/Bids.jsx";
import Projects from "../../views/pages/Upwork/Projects.jsx";
import BidderStatistics from "../../views/pages/Upwork/BidderStatistics.jsx";
import AgentStatistics from "../../views/pages/Upwork/AgentStatistics.jsx";
import Trackings from "../../views/pages/Upwork/Tracking.jsx";
import Users from "../../views/pages/Upwork/AllUsers.jsx";
import Chat from "../../views/pages/Chat";
import Task from "../../views/pages/Employees/Task.jsx";
import Settings from "../../views/pages/Settings/Settings.jsx";

const AppContainer = () => {
  const [isSidebarExpanded, setSidebarExpanded] = useState(true);

  const role = useSelector((state) => state?.auth?.userRole);
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);

  const routingObjects = [
    {
      id: 1,
      path: "admin-dashboard",
      element: <AdminDashboard />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 2,
      path: "admin-leaves",
      element: <AdminLeave />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 3,
      path: "employees",
      element: <AllEmpoyee />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 4,
      path: "admin-attendance",
      element: <AttendenceAdmin />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 6,
      path: "departments",
      element: <Department />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 7,
      path: "designations",
      element: <Designation />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 8,
      path: "employeeprofile/:id",
      element: <EmployeeProfile />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 9,
      path: "employees-list",
      element: <EmployeeList />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 10,
      path: "assets",
      element: <Assets />,
      role: ["admin", "manager", "hr"],
    },
    {
      id: 11,
      path: "holidays",
      element: <HolidayManagement />,
    },
    {
      id: 12,
      path: "employee-dashboard",
      element: <EmployeeDashboard />,
    },
    {
      id: 5,
      path: "attendance-employee",
      element: <AttendanceEmployee />,
    },
    {
      id: 13,
      path: "leaves-employee",
      element: <EmployeeLeave />,
    },
    {
      id: 14,
      path: "profile",
      element: <Profile />,
    },
    {
      id: 15,
      path: "salary-view",
      element: <PaySlip />,
    },
    {
      id: 16,
      path: "payroll-items",
      element: <PayrollItems />,
    },
    {
      id: 17,
      path: "employee-salary",
      element: <EmployeeSalary />,
    },
    {
      id: 18,
      path: "fields",
      element: <Fields />,
    },
    {
      id: 19,
      path: "sales",
      element: <Estimates />,
    },
    {
      id: 20,
      path: "create-sale",
      element: <CreateEstimate />,
    },
    {
      id: 21,
      path: "edit-sale",
      element: <EditEstimate />,
    },
    {
      id: 22,
      path: "calls",
      element: <Calls />,
    },
    {
      id: 23,
      path: "create-call",
      element: <CreateCall />,
    },
    {
      id: 24,
      path: "edit-call",
      element: <EditCall />,
    },
    {
      id: 25,
      path: "daily-report",
      element: <DailyReport />,
    },
    {
      id: 26,
      path: "user-report",
      element: <UserReport />,
    },
    {
      id: 26,
      path: "error",
      element: <Error404 />,
    },
    {
      id: 27,
      path: "bids",
      element: <Bids />,
    },
    {
      id: 28,
      path: "projects",
      element: <Projects />,
    },
    {
      id: 29,
      path: "bidder-statistics",
      element: <BidderStatistics />,
    },
    {
      id: 30,
      path: "agent-statistics",
      element: <AgentStatistics />,
    },
    {
      id: 31,
      path: "project-tracking", 
      element: <Trackings />,
    },
    {
      id: 32,
      path: "upwork-users", 
      element: <Users />,
    },
    {
      id: 33,
      path: "chat",
      element: <Chat />,
      role: ["admin", "manager", "hr", "employee", "supervisor"],
    },
    {
      id: 34,
      path: "Task",
      element: <Task />,
      role: ["admin", "manager", "hr", "employee", "supervisor"],
    },
    {
      id: 35,
      path: "settings",
      element: <Settings />,
      role: ["admin"],
    },
  ];

  const SidebarLayout = () => (
    <>
      <Header
        setSidebarExpanded={setSidebarExpanded}
        isSidebarExpanded={isSidebarExpanded}
      />
      <Sidebar isSidebarExpanded={isSidebarExpanded} />
      <Outlet />
    </>
  );

  const mobileResponsive = (event) => {
    const excludedHeader = document.querySelector(".header");
    const excludedSidebar = document.querySelector(".sidebar");

    if (
      !excludedHeader.contains(event.target) &&
      !excludedSidebar.contains(event.target)
    ) {
      document.body.classList.remove("slide-nav");
    }
  };

  if (
    isLoggedIn &&
    role !== "admin" &&
    window.innerWidth < 640 &&
    process.env.REACT_APP_BASE_ENV !== "production"
  ) {
    return <h1>Access Denied: You are not authorized to use it on mobile.</h1>;
  }

  return (
    <>
      <div className="main-wrapper" onClick={mobileResponsive}>
        <Routes>
          <Route path={"/*"} element={<SidebarLayout />}>
            {routingObjects.map((item) => (
              <Route
                key={item.id}
                path={item.path}
                element={
                  <ProtectedRoute
                    children={item.element}
                    requiredRole={item.role}
                  />
                }
              />
            ))}
          </Route>

          <Route path={"/*"} element={<SidebarLayout />}>
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default AppContainer;
